export default "__VITE_ASSET__BtyluYbR__"